import { combineReducers } from "redux";

import usuario from "./usuario/reducer";

export default combineReducers({
  usuario,
});
